import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toast } from '@/utils/message';
import request from '@/utils/request';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XUpload',
  props: {
    action: {
      type: String,
      required: true
    },
    value: Object,
    callback: Function,
    upload: Function,
    accept: String,
    multiple: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: () => []
    },
    limit: Number,
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    timeout: {
      type: Number,
      default: 6 * 60 * 1000
    },
    onExceed: Function,
    onChange: Function,
    onRemove: Function,
    onSuccess: Function,
    onError: Function,
    onModified: Function,
    beforeUpload: Function
  },
  setup(__props, {
    expose: __expose
  }) {
    /**
     * 上传组件
     * 封装自el-upload
     * 实现了多文件同时上传的功能
     *
     * @author Jay Qing
     */
    const props = __props;
    const callbackFn = props.callback ?? defaultCallback;
    const onSuccessFn = props.onSuccess ?? defaultSuccess;
    const onErrorFn = props.onError ?? defaultError;
    const onModifiedFn = props.onModified ?? defaultModified;
    const uploadFileList = ref([...props.fileList]);
    const onExceedFn = ref(props.onExceed ?? defaultExceed);
    const uploader = ref();
    function doUpload() {
      const files = uploadFileList.value;
      const data = props.value;
      if (!files || files.length < 1) {
        return false;
      }
      if (props.beforeUpload && !props.beforeUpload(files, data)) {
        return;
      }
      console.log(3);
      Promise.all(files.flatMap(file => checkModification(file))).then(() => {
        console.log(2);
        performUpload(files, data);
      }).catch(file => {
        console.log(1);
        onModifiedFn(file, files);
      });
      return false;
    }
    /**
     * 检查文件是否已发生改变
     *
     * @param file 文件
     */
    function checkModification(file) {
      return file.raw?.slice(0, 1).arrayBuffer().catch(() => {
        return Promise.reject(file);
      });
    }
    function performUpload(files, data) {
      console.log(files);
      const form = new FormData();
      files.forEach(file => {
        form.append('file', file.raw);
      });
      if (data) {
        Object.keys(data).forEach(key => form.append(key, data[key]));
      }
      if (props.action) {
        const result = request({
          url: props.action,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          method: 'post',
          data: form,
          timeout: props.timeout
        }, {
          showErrorMessage: false
        });
        if (callbackFn) {
          callbackFn(result);
        }
      } else if (props.upload) {
        props.upload(form);
      }
    }
    function change(uploadFile, uploadFiles) {
      uploadFileList.value = uploadFiles.filter(item => item.status === 'ready');
      if (props.onChange) {
        props.onChange(uploadFile, uploadFiles);
      }
    }
    function remove(uploadFile, uploadFiles) {
      uploadFileList.value = uploadFiles.filter(item => item.status === 'ready');
      if (props.onRemove) {
        props.onRemove(uploadFile, uploadFiles);
      }
    }
    function defaultModified(file) {
      toast.warn(`文件 ${file.name} 已修改，请重新选择此文件`);
    }
    function defaultSuccess() {
      toast.success(`上传成功`);
    }
    function defaultError() {
      toast.error('上传出错');
    }
    function defaultExceed() {
      toast.warn(`最多只能选择${props.limit}个文件`);
    }
    function defaultCallback(promise) {
      promise.then(result => {
        onSuccessFn(result, props.fileList);
      }).catch(error => {
        onErrorFn(error, props.fileList);
      });
    }
    function submit() {
      doUpload();
    }
    function clearFiles() {
      uploader.value?.clearFiles();
    }
    __expose({
      submit,
      clearFiles
    });
    return (_ctx, _cache) => {
      const _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createBlock(_component_el_upload, {
        ref_key: "uploader",
        ref: uploader,
        accept: __props.accept,
        data: __props.value,
        "auto-upload": false,
        "file-list": __props.fileList,
        disabled: __props.disabled,
        multiple: __props.multiple,
        limit: __props.limit,
        "on-exceed": _unref(onExceedFn),
        "on-change": change,
        "on-remove": remove,
        drag: ""
      }, _createSlots({
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
        _: 2
      }, [_ctx.$slots.trigger ? {
        name: "trigger",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "trigger")]),
        key: "0"
      } : undefined, _ctx.$slots.tip ? {
        name: "tip",
        fn: _withCtx(() => [_renderSlot(_ctx.$slots, "tip")]),
        key: "1"
      } : undefined]), 1032, ["accept", "data", "file-list", "disabled", "multiple", "limit", "on-exceed"]);
    };
  }
});